"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InvalidationPolicyCache_1 = require("./InvalidationPolicyCache");
exports.InvalidationPolicyCache = InvalidationPolicyCache_1.default;
//# sourceMappingURL=index.js.map